var environment = require('../environment.js');

/* Add the contextual CSP policy to the meta tag with an iffe */
(function() {
  var cspMetaTag = document.createElement('meta');
  cspMetaTag.setAttribute("http-equiv", "Content-Security-Policy");
  cspMetaTag.setAttribute("content", environment.csp_policy);

  var head = document.getElementsByTagName('head')[0];
  head.insertBefore(cspMetaTag, head.firstChild);
})();



// WEBPACK FOOTER //
// ./content_security_policy/make_CSP_meta_tag.js